// @flow

import type { EmployeesState } from "@modules/employee/reducer";

export const onGetActiveClients = (state: EmployeesState) => () => {
  return {
    ...state,
    error: null,
    clients: {
      ...state.clients,
      requestsInProgress: ++state.clients.requestsInProgress,
    },
  };
};

export const onGetActiveClientsSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    clients: {
      ...state.clients,
      requestsInProgress: --state.clients.requestsInProgress,
      list: payload,
    },
  };
};

export const onGetActiveClientsError = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    clients: {
      ...state.clients,
      requestsInProgress: --state.clients.requestsInProgress,
      list: {
        ...state.clients.list,
        content: [],
      },
    },
  };
};
